import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import "../node_modules/jquery/dist/jquery.js";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/jquery/dist/jquery.min.js'
import '../node_modules/bootstrap/dist/js/bootstrap.min.js'
import Home from "./pages/User/Home/Home";
import Blog from "./pages/User/Blog/Blog.js";
import BlogDetail from "./pages/User/Blog/BlogDetail.js";
import Login from "./pages/Admin/login/login.js";
import UploadBlogImage from "./components/Admin/UploadBlogImage/UploadBlogImage.js";
import AdminDashboard from "./pages/Admin/Dashboard/AdminDashboard.js";
import AirportToDoor from "./pages/User/Services/AirportToDoor.js";
import DoorToAirport from "./pages/User/Services/DoorToAirport.js";
import InternationalLuggageShipping from "./pages/User/Services/InternationalLuggageShipping.js";
import ExcessBaggageDelivery from "./pages/User/Services/ExcessBaggageDelivery.js";
import ExtraBaggageCost from "./pages/User/Services/ExtraBaggageCost.js";
import UnaccompaniedBaggage from "./pages/User/Services/UnaccompaniedBaggage.js";
import AboutUs from "./pages/User/AboutUs/AboutUs";
import Faqs from "./pages/User/Faqs/Faqs.js";
import ContactUs from "./pages/User/ContactUs/ContactUs.js";
import AddBlog from "./components/Admin/AddBlog/AddBlog.js";

function App() {
  return (
    <Router>
      <Routes>
        {/* ADMIN  */}
        <Route path="/admin/login" element={<Login/>} /> 
        <Route path="/admin/dashboard" element={<AdminDashboard/>} /> 
        <Route path="admin/addBlog" element={<AddBlog/>} /> 
        <Route path="admin/uploadBlogImage" element={<UploadBlogImage/>} /> 
        {/* USER  */}
        <Route path="/" element={<Home />} />
        <Route path='/about-us' element={<AboutUs/>}/>
        <Route path='/blog' element={<Blog/>}/>
        <Route path="/blog/:id" element={<BlogDetail/>} /> 
        <Route path='/services/airport-to-door' element={<AirportToDoor/>}/>
        <Route path='/services/door-to-airport' element={<DoorToAirport/>}/>
        <Route path='/services/international-luggage-shipping' element={<InternationalLuggageShipping/>}/>
        <Route path="/services/excess-baggage-delivery" element={<ExcessBaggageDelivery/>} />
        <Route path="/services/extra-baggage-cost" element={<ExtraBaggageCost/>} />
        <Route path="/services/unaccompanied-baggage" element={<UnaccompaniedBaggage/>} />
        <Route path="/faqs" element={<Faqs/>} />
        <Route path="/contact-us" element={<ContactUs/>} />
      </Routes>
    </Router>
  );
}

export default App;
